import React from 'react';
import { Button } from './Button';
interface Tomo {
  num: string;
  icon: string;
  title: string;
  desc: string;
}
export function ProductShowcase() {
  const tomos: Tomo[] = [{
    num: '01',
    icon: '📘',
    title: 'Introducción a la Acuicultura',
    desc: 'Historia, sistemas, especies, recursos hídricos y perfil del técnico. Donde el alumno que nunca vio un estanque entiende por qué la acuicultura importa y por qué él es parte de eso.'
  }, {
    num: '02',
    icon: '📗',
    title: 'Calidad del Agua y Ecosistemas Acuáticos',
    desc: 'Los 10 parámetros esenciales, el ciclo del nitrógeno, sistemas de filtración y monitoreo sistemático. Donde entienden que el agua no es agua — es el ambiente de producción completo.'
  }, {
    num: '03',
    icon: '📙',
    title: 'Piscicultura y Especies Comerciales',
    desc: 'Tilapia, trucha, salmón, camarón, bagre, cachama, moluscos y especies nativas. Fichas técnicas completas, sistemas de cultivo y estrategias de comercialización por especie.'
  }, {
    num: '04',
    icon: '📕',
    title: 'Alimentación y Nutrición Acuícola',
    desc: 'FCR, tablas de alimentación por especie y temperatura, formulación básica de dietas y proteínas alternativas. Donde el alumno entiende que el alimento es el 70% del costo — y el técnico que lo maneja bien, hace la diferencia.'
  }, {
    num: '05',
    icon: '📓',
    title: 'Sanidad y Manejo Productivo',
    desc: 'Bioseguridad, enfermedades bacterianas, virales y parasitarias, BPA, uso responsable de medicamentos y seguridad laboral. El tomo que puede salvar una producción completa.'
  }, {
    num: '06',
    icon: '📔',
    title: 'Sustentabilidad e Innovación Acuícola',
    desc: 'RAS, Biofloc, Acuaponía, IoT, Inteligencia Artificial, economía circular, cambio climático y visión estratégica del sector. Donde tus alumnos hablan el idioma del futuro de la producción acuícola.'
  }];
  return <section className="py-9 px-4 bg-brand-cream" data-id="element-145">
      <div className="max-w-5xl mx-auto" data-id="element-146">
        <div className="text-center mb-6" data-id="element-147">
          <p className="orange-text font-display font-bold uppercase tracking-widest text-sm mb-2" data-id="element-148">
            📚 Los 6 Tomos Maestros
          </p>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white uppercase leading-tight" data-id="element-149">
            <span className="orange-text" data-id="element-150">500+ páginas</span> de material
            técnico aplicado
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-151">
          {tomos.map((t, i) => <div key={i} className="brunson-card rounded-lg p-4 md:p-5 flex gap-3 hover:translate-y-[-2px] transition-transform brunson-shadow" data-id="element-152">
              <div className="shrink-0" data-id="element-153">
                <div className="w-14 h-14 md:w-16 md:h-16 bg-brand-orange text-white rounded-lg flex flex-col items-center justify-center font-display font-bold" data-id="element-154">
                  <span className="text-[9px] uppercase tracking-widest leading-none" data-id="element-155">
                    Tomo
                  </span>
                  <span className="text-2xl leading-none mt-0.5" data-id="element-156">{t.num}</span>
                </div>
              </div>
              <div className="flex-1" data-id="element-157">
                <h3 className="font-display font-bold text-white text-base md:text-lg uppercase leading-tight mb-1" data-id="element-158">
                  {t.icon} {t.title}
                </h3>
                <p className="text-xs md:text-sm text-brand-mute leading-snug font-medium" data-id="element-159">
                  {t.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="max-w-md mx-auto mt-7" data-id="element-160">
          <Button data-id="element-161">🚀 Quiero el Sistema Acuicultura Pro</Button>
        </div>
      </div>
    </section>;
}